import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from 'react-router-dom';

const FromEditCategory = () => {
  document.title = "Edit Category | Uma Classes";
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
  });

  const [imageFile, setImageFile] = useState(null); // State for new image file
  const [existingImage, setExistingImage] = useState(null); // State for existing image URL
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        const token = localStorage.getItem('token');
        const CategoryResponse = await axios.get(`https://uma.aasmo.in/api/admin/getbyid-category/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const CategoryData = CategoryResponse;
        setFormData({
          name: CategoryData.name,
        });
        setExistingImage(CategoryData.image); // Set the existing image URL
      } catch (error) {
        console.error("Error fetching Category details:", error);
      }
    };

    fetchCategory();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]); // Store the selected file
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const formDataToSend = new FormData();
      formDataToSend.append('name', formData.name);
      if (imageFile) {
        formDataToSend.append('image', imageFile); // Append the new image file if selected
      }

      await axios.put(`https://uma.aasmo.in/api/admin/update-category/${id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", // Ensure multipart/form-data for file upload
        }
      });
      setSuccessMessage("Category edited successfully");
      setErrorMessage("");
    } catch (error) {
      console.error("Error editing Category:", error);
      setSuccessMessage("");
      setErrorMessage("Error editing Category");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Category" breadcrumbItem="Edit" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-2 col-form-label">
                        Category Name
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="image" className="col-md-2 col-form-label">
                        Category Image
                      </label>
                      <div className="col-md-12">
                        {existingImage && (
                          <div className="mb-2">
                            <img src={existingImage} alt="Category" style={{ maxWidth: '200px', maxHeight: '200px' }} />
                          </div>
                        )}
                        <input
                          className="form-control"
                          type="file"
                          id="image"
                          name="image"
                          onChange={handleFileChange} // Handle file change
                          accept="image/*"
                        />
                      </div>
                    </Row>

                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <button type="submit" className="btn btn-primary">Edit</button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FromEditCategory;
